$(document).ready(function () {

    //console.log(location.hostname)

    $("#form-customer-register").on('submit', function (e) {
        e.preventDefault()
        let data = new FormData(this)
        console.log("asd")
        clearSpan()
        sendRegisterData(data, '/registro-cliente')
    })

    function sendRegisterData(data, route) {
        $("#div_loading").addClass("loading-almadia")
        $.ajax({
            url: route, type: "post", data: data, processData: false, contentType: false, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (response) {
                setTimeout(function () {
                    $("#div_loading").removeClass("loading-almadia")
                    if (response.success == "success") {
                        window.location.href = "/carrito/pagar";
                    }
                }, 3000) // Bajar el tiempo, pedir otro gif
            }, error: function (errors, xhr, status,) {
                $("#div_loading").removeClass("loading-almadia")
                var indices = errors.responseJSON.errors;
w
                $.each(indices, function (index, value) {
                    $(".item-error-" + index).html(value[0] + '<br>')
                })
            }
        })
    }


    // Fecha
    let dias = $("#day");
    dias.find('option').remove();
    for (let i = 1; i <= 31; i++) {
        if (i < 10) {
            i = "0" + i;
        }
        dias.append('<option value="' + i + '">' + i + '</option>');
    }

    if ($("#aniho").length > 0) {
        setTimeout(function () {
            let aniho = $("#aniho").val();
            let mes = $("#mes").val();
            calculate_last_day(aniho, mes);

        }, 150);

        function calculate_last_day(aniho, mes) {
            let diasMes = new Date(aniho, mes, 0).getDate();
            let diasSemana = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
            let dia_final = 0;
            let dias = $("#day");
            for (let dia = 1; dia <= diasMes; dia++) {
                var indice = new Date(aniho, mes - 1, dia).getDay();
                dia_final = dia;
            }

            let dia = $("#day").val();

            if (dia > 0 && dia <= dia_final) {
                $("#day").val(dia);
            } else {
                alertError('Seleccionar día correcto. ')
                dias.find('option').remove();
                for (let i = 1; i <= dia_final; i++) {
                    dias.append('<option value="' + i + '">' + i + '</option>');
                }
            }

        }

        window.valid_day = function () {
            let aniho = $("#aniho").val();
            let mes = $("#mes").val();
            calculate_last_day(aniho, mes);
        }
    }

    $(".oppen-modal-email").on('click', function (e) {
        e.preventDefault();
        $("#modal-email").modal('show');
    })

    function clearSpan() {
        $(".item-error-name").html("")
        $(".item-error-apellidos").html("")
        $(".item-error-phone").html("")
        $(".item-error-email").html("")
        $(".item-error-password").html("")
        $(".item-error-password_confirmation").html("")
        $(".item-error-mes").html("")
        $(".item-error-aniho").html("")
        $(".item-error-politica").html("")
    }


})
